export function buildCandidatePhotoPath(slug: string): string {
  return `/candidatos/${encodeURIComponent(slug)}.jpg`;
}
